import {getUploadSecret,getCVFiles} from "@/api/file";

const state = {
}

const mutations = {
}

const actions = {
  getuploadsecret({commit},data){
    return new Promise((resolve, reject) => {
      getUploadSecret(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcvfile({commit},data){
    return new Promise((resolve, reject) => {
      getCVFiles(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
